import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {
  selectedItem = 'calendarItem';

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activatedRoute.fragment.subscribe((fragment: string) => {
        if (fragment === 'display') {
          this.selectedItem = 'displayItem';
        } else if (fragment === 'booking') {
          this.selectedItem = 'bookingItem';
        } else if (fragment === 'branding') {
          this.selectedItem = 'brandingItem';
        } else {
          this.selectedItem = 'calendarItem';
        }
    });
  }
}
